import EverTrue from 'app';
import PropTypes from 'prop-types';
import EmailCardSelectors from './email-card-selectors';
import EmailCardHeader from './email-card-header';
import EmailCardBody from './email-card-body';
import IndicatorGroup from '../indicators/indicator-group';
import { useGlobalDrawerProvider } from 'components/drawer/context/global-drawer-context';
import { trackOutreachAction } from 'apps/outreach/utils/utils';
import { isEmpty } from '@evertrue/sdk';

const EmailCard = ({
  email = {},
  handleBulkSelect = () => {},
  threadCount = 0,
  isLabelFilterApplied = false,
  filterType = '',
}) => {
  const {
    id,
    nylas_schedule_id,
    email_template = {},
    journey_response,
    thankview_videos = [],
    status,
    nylas_thread_id,
    email_attachments = [],
  } = email;
  const { addDrawer, drawers } = useGlobalDrawerProvider();

  const handleClickEmail = (e) => {
    // Check if click originated from an interactive element
    const isInteractiveElement = e.target.closest(
      'button, a, input, select, textarea, [role="button"], [role="menuitem"], .et--checkbox, .et--actions-menu'
    );

    if (isInteractiveElement) {
      return; // Don't handle the click if it's on an interactive element
    }

    if (!nylas_schedule_id && status === 'DRAFT') {
      const drawer = drawers.find((d) => {
        return d.type === 'emailer' && d.childProps?.email?.id === id;
      });
      if (!drawer) {
        trackOutreachAction('open_emailer');
        addDrawer('emailer', {
          drawerTitle: `Edit - Draft`,
          email,
        });
      }
    } else if (status === 'SENT' || status === 'REPLIED') {
      EverTrue.UrlManager.navigate(`/outreach/email/thread/${nylas_thread_id}`, true, false);
    } else {
      EverTrue.UrlManager.navigate(`/outreach/email/scheduled/${id}`, true, false);
    }
  };

  const shouldShowIndicatorGroup =
    threadCount > 1 ||
    !isEmpty(email_template) ||
    journey_response ||
    thankview_videos?.length > 0 ||
    email_attachments?.length > 0;

  return (
    <div className="email-card">
      <div className="email-card-main">
        <EmailCardSelectors email={email} handleBulkSelect={handleBulkSelect} threadCount={threadCount} />
        <div className="email-card-content">
          <div onClick={handleClickEmail}>
            <EmailCardHeader email={email} />
            <div className="email-card-body-wrapper">
              <EmailCardBody email={email} isLabelFilterApplied={isLabelFilterApplied} filterType={filterType} />
            </div>
          </div>
          {shouldShowIndicatorGroup && (
            <div className="outreach-indicator-group">
              <IndicatorGroup
                threadCount={threadCount}
                emailTemplate={email_template}
                journeyResponse={journey_response}
                thankviewVideos={thankview_videos}
                attachments={email_attachments}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

EmailCard.propTypes = {
  email: PropTypes.object.isRequired,
  handleBulkSelect: PropTypes.func,
  threadCount: PropTypes.number,
  isLabelFilterApplied: PropTypes.bool,
  filterType: PropTypes.string,
};

export default EmailCard;
